const updates = [
  {
    id: 1,
    date: '07-31',
    title: '庆余年第二季',
    desc: '第36集大结局已更新',
    tag: '今日更新',
    tagColor: 'bg-primary-500 text-white',
  },
  {
    id: 2,
    date: '07-31',
    title: '与凤行',
    desc: '第39集全集上线',
    tag: '全集更新',
    tagColor: 'bg-accent-500 text-background-50',
  },
  {
    id: 3,
    date: '07-30',
    title: '狐妖小红娘月红篇',
    desc: '第28-30集连更三集',
    tag: '',
    tagColor: '',
  },
  {
    id: 4,
    date: '07-30',
    title: '墨雨云间',
    desc: '第40集大结局上线',
    tag: '大结局',
    tagColor: 'bg-primary-500 text-white',
  },
  {
    id: 5,
    date: '07-29',
    title: '玫瑰的故事',
    desc: '第22-24集已更新',
    tag: '',
    tagColor: '',
  },
  {
    id: 6,
    date: '07-29',
    title: '繁花',
    desc: '沪语版全集上线',
    tag: '特别版',
    tagColor: 'bg-secondary-500 text-background-50',
  },
  {
    id: 7,
    date: '07-28',
    title: '长相思',
    desc: '第二季第15-16集更新',
    tag: '',
    tagColor: '',
  },
  {
    id: 8,
    date: '07-28',
    title: '莲花楼',
    desc: '4K修复版全集上线',
    tag: '高清修复',
    tagColor: 'bg-accent-500 text-background-50',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            更新动态
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            每日剧集更新速递，追剧永不掉队
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300"></div>
          <div className="space-y-4">
            {updates.map((update) => (
              <a
                key={update.id}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-14 cursor-pointer group"
              >
                <div className="absolute left-2 md:left-3.5 top-1.5 w-4 h-4 rounded-full border-2 border-background-50 bg-primary-400 z-10"></div>
                <div className="flex-shrink-0 w-14 text-right">
                  <span className="text-xs font-medium text-foreground-400 bg-background-100 px-2 py-1 rounded whitespace-nowrap">
                    {update.date}
                  </span>
                </div>
                <div className="flex-1 min-w-0 pb-3 border-b border-background-200">
                  <div className="flex items-center gap-2 flex-wrap mb-0.5">
                    <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                      {update.title}
                    </h3>
                    {update.tag && (
                      <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${update.tagColor} whitespace-nowrap`}>
                        {update.tag}
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-foreground-600">{update.desc}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}